import React from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { Link as RouterLink } from '@tanstack/react-router'
import privacyPolicyMarkdown from './privacy-policy.md?raw'

export const PrivacyPolicyPage: React.FC = () => {
  return (
    <div className="flex flex-1 w-full justify-center">
      <article className="flex-1 max-w-4xl px-4 md:px-6 lg:px-8 py-12">
        <div className="bg-card border border-border rounded-lg shadow-sm p-6 md:p-10">
          <div className="prose prose-slate dark:prose-invert max-w-none">
            <ReactMarkdown
              remarkPlugins={[remarkGfm]}
              components={{
                h1: ({ node, ...props }) => (
                  <h1
                    className="text-3xl md:text-4xl font-bold tracking-tight text-foreground"
                    {...props}
                  />
                ),
                h2: ({ node, ...props }) => (
                  <h2
                    className="text-2xl md:text-3xl font-semibold text-foreground mt-10"
                    {...props}
                  />
                ),
                h3: ({ node, ...props }) => (
                  <h3
                    className="text-xl md:text-2xl font-semibold text-foreground mt-8"
                    {...props}
                  />
                ),
                p: ({ node, ...props }) => (
                  <p
                    className="text-base leading-relaxed text-muted-foreground"
                    {...props}
                  />
                ),
                li: ({ node, ...props }) => (
                  <li
                    className="leading-relaxed text-muted-foreground"
                    {...props}
                  />
                ),
                strong: ({ node, ...props }) => (
                  <strong
                    className="text-foreground font-semibold"
                    {...props}
                  />
                ),
                a: ({ node, href = '', children, ...props }) => {
                  if (href.startsWith('/')) {
                    return (
                      <RouterLink
                        to={href as any}
                        className="text-primary underline hover:text-primary/80"
                        {...props}
                      >
                        {children}
                      </RouterLink>
                    )
                  }
                  return (
                    <a
                      href={href}
                      className="text-primary underline hover:text-primary/80"
                      target="_blank"
                      rel="noreferrer"
                      {...props}
                    >
                      {children}
                    </a>
                  )
                },
              }}
            >
              {privacyPolicyMarkdown}
            </ReactMarkdown>
          </div>
        </div>
      </article>
    </div>
  )
}
